/* Promotion Banner */
cmmInsertPromotionBanner({
  selector: '#site_content > div.site_content',
  insertMode: 'prepend',
  buttonLink: '/promotions',
  extraStyle: {
    position: 'sticky',

    zIndex: '1',
  },
});
/* Birdeye */
cmmFireAfterUserInteraction(() => {
  console.log('birdeye');
  // loadScriptGTM('https://grow.creekmoremarketing.com/embed/v6/160917804550916/1/1636783883/7d19ce03347c4c4226afe11307d1d3104d869f337884152c')
});

/* ConvertBoost© */
cmmSetupConvertBoost({
  cta_options: [
    {
      mode: 'modal',
      icon: 'phone',
      icon_size: 'podium',
      text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
      font: {
        family: 'AUTO',
      },
      devices: ['desktop', 'laptop', 'tablet', 'mobile'],
    },
  ],

  modal_options: {
    header_text:
      '<img style="max-width:300px;" src="https://irp-cdn.multiscreensite.com/686261e9/dms3rep/multi/desktop/Window%20Magic%20Blinds%20%26%20Drapery%2C%20Inc-1682x152.%20logo.png">',
    header_color: '#ffffff',
    description_text:
      'Ready to transform your space?<br>Our design team is here to help!',
    font: {
      family: 'AUTO',
    },
    buttons: [
      {
        title: '(281) 955-5676',
        link: 'tel:+12819555676',
        txt_color_hover: '#f5842a',
        bg_color: '#f5842a',
        class_list: ['call-us'],
        icon: 'phone',
      },
      {
        title: 'TEXT US',
        link: 'sms:+12819555676',
        txt_color_hover: '#f5842a',
        bg_color: '#f5842a',
        class_list: ['text-us'],
        icon: 'sms-solid',
      },
      {
        title: 'VISIT SHOWROOM',
        link: 'https://www.google.com/maps/place/Window+Magic+Blinds+and+Drapery,+Inc/@29.959434,-95.5491377,17z/data=!4m13!1m7!3m6!1s0x8640cde5c882aa3b:0xb0f060a57fe04f2!2s17743+Tomball+Pkwy,+Houston,+TX+77064,+USA!3b1!8m2!3d29.959434!4d-95.546949!3m4!1s0x8640cde67b4f695d:0xd36f3decbe27b01d!8m2!3d29.959434!4d-95.546949',
        link_target: '_blank',
        txt_color_hover: '#f5842a',
        bg_color: '#f5842a',
        class_list: ['visit-showroom'],
        icon: 'map-pin',
      },
      {
        title: 'CONTACT US',
        link: 'https://www.windowmagiconline.com/contact-us',
        bg_color: '#f5842a',
        txt_color_hover: '#f5842a',
        class_list: ['contact-us'],
        icon: 'email',
      },
    ],
    footer_text:
      'Window Magic Blinds and Drapery, Inc aims to be your personal interior designer and and premier source for window treatments and motorized window coverings!',
    footer_color: '#000',
  },
}).then((_) => {
  /* ConvertBoost©  Event Tracking */
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .call-us',
      action: 'Call Us - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .text-us',
      action: 'Text Us - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .visit-showroom',
      action: 'Visit Shworoom - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .contact-us',
      action: 'Request a Consultation - ConvertBoost©',
      event: 'click',
    },
  ]);
});
